export function format(date){
  var d = new Date(date)
  var s =
    d.getFullYear() + '-' + 
    ("00" + (d.getMonth() + 1)).slice(-2) + '-' + 
    ("00" + d.getDate()).slice(-2) + ' ' + 
    ("00" + d.getHours()).slice(-2) + ':' + 
    ("00" + d.getMinutes()).slice(-2) + ':' + 
    ("00" + d.getSeconds()).slice(-2)
  return s
}



// WEBPACK FOOTER //
// ./src/client/lib/date.js